// import React from "react";
// import Shray_Pathak from "../directorimages/Shray_Pathak.jpeg";
// import Atharva from "../directorimages/atharva.jpg";
// import shashi from "../directorimages/shashi.png";
// import rajeev2 from "../directorimages/rajeev2.png";
// import rajeev4 from "../directorimages/rajeev4.jpg";
// import naveen from "../directorimages/Naveen.png";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faGoogle, faLinkedin } from "@fortawesome/free-brands-svg-icons";
// import logo from "../global-images/logo.png";

// // Inside your component's render method
// import "../styles/Dmssg.css";

// const directors = [
//   {
//     imgSrc: rajeev4,
//     name: "Prof. Rajeev Ahuja",
//     designation: "Chairman",
//     message:
//       "IIT Ropar's Technology Business Incubator Foundation is engaged in pushing forward with the mission of promoting entrepreneurial activities among our students and faculties and people of the region. We offer the following services to the companies incubated with us.",
//     add: "https://iitrpr.irins.org/profile/227381",
//     linkedin: "https://scholar.google.com/citations?user=OqyvV_oAAAAJ&hl=en",
//   },
//   {
//     imgSrc: Shray_Pathak,
//     name: "Dr. Shray Pathak",
//     designation: "Faculty In-Charge",
//     message:
//       "TBIF at IIT Ropar is a critical driver for innovation and entrepreneurship in the region. By fostering a culture of creativity and enterprise, we aim to transform promising ideas into scalable solutions, providing a launchpad for startups to grow and thrive.",
//     add: "https://www.linkedin.com/in/shray-pathak-4aa852300/?originalSubdomain=in",
//     linkedin:
//       "https://www.linkedin.com/in/shray-pathak-4aa852300/?originalSubdomain=in",
//   },

//   {
//     imgSrc: Atharva,
//     name: "Atharva Poundarik",
//     // designation: 'Member TBIF',

//     message:
//       "At TBIF, we are committed to creating a vibrant entrepreneurial ecosystem where students, faculty, and regional innovators collaborate to bring ideas to life. Our infrastructure, mentorship, and funding access are designed to support ventures from inception to success.",
//     add: "https://iitrpr.ac.in/mme/atharva",
//     linkedin: "https://www.linkedin.com/in/atharva-poundarik-44723b44/",
//   },
//   {
//     imgSrc: shashi,
//     name: "Dr. Shashi Shekhar Jha",
//     // designation: 'Member TBIF',
//     message:
//       "Through TBIF, IIT Ropar is dedicated to empowering innovators with the tools, guidance, and environment necessary to turn concepts into impactful ventures. We are here to bridge the gap between research and real-world implementation with sustainable solutions.",
//     add: "https://iitrpr.irins.org/profile/105191",
//     linkedin:
//       "https://www.linkedin.com/in/jhashashishekhar/?originalSubdomain=sg",
//   },
//   {
//     imgSrc: naveen,
//     name: "Prof. Navin Kumar",
//     // designation: 'Member TBIF',
//     message:
//       "TBIF serves as a catalyst for entrepreneurial growth, offering a nurturing ground for startups to innovate, iterate, and succeed. Our focus is to enable founders with the right support system—mentorship, funding, and strategic guidance—to create lasting impact.",

//     add: "https://iitrpr.irins.org/profile/50300",
//     linkedin:
//       "https://www.linkedin.com/in/navin-kumar-a4a4a45/?originalSubdomain=in",
//   },
// ];

// function DMssg() {
//   return (
//     <div className="p-10 bg-white">
//       {/* <div className='m-24'></div> */}
//       {/* <h2 className=' bg-clip-text text-transparent mb-5 bg-gradient-to-tr from-purple-900 to-green-500 text-center font-bold text-5xl '>Directors</h2> */}
//       <h2 className="bg-clip-text text-transparent mb-5 text-black text-center font-bold md:text-5xl text-4xl mt-20">
//         Board Of Directors
//       </h2>
//       <div className="p-5 flex grid lg:grid-cols-2 rounded-3xl md:grid-cols-2 sm:grid-cols-1 justify-center items-center h-auto ">
//         {directors.map((director, index) => (
//             <div key={index} className={`text-white rounded-2xl pb-10 pt-4 hover:scale-105 transition flex justify-between  duration-100 ease-in-out bg-zinc-900`}>
//               <div className="grid grid-cols-1 justify-items-center">
//                 <img
//                   src={director.imgSrc}
//                   alt={director.name}
//                   className="outTeam__cardImg fa-border border-blue-200 border-2"
//                 />
//                 <div className="p-2 font-montserrat font-bold  rounded  text-center">
//                   {director.name}
//                 </div>
//                 <div className=" font-montserrat rounded  text-center">
//                   {director.designation}
//                 </div>
//                 <div className="flex justify-center items-center">
//                   {/* <a href={director.add} target='_blank'><img className='bg-black invert rounded-full' height={40} width={40} src={logo} ></img></a> */}
//                     <a href={director.add} target="_blank">
//                     <FontAwesomeIcon
//                       icon={faGoogle}
//                       className="text-3xl text-red-500 p-2"
//                     />
//                   </a>
//                   <a href={director.linkedin} target="_blank">
//                     <FontAwesomeIcon
//                       icon={faLinkedin}
//                       className="text-4xl text-blue-300 p-2"
//                     />
//                   </a>
//                 </div>
//               </div>
//               <div>
//                 <div className="border-3 w-1/2 font-montserrat border-white mt-4 text-lg text-justify">
//                   {director.message}
//                 </div>
//               </div>
//           </div>
          
//         ))}
//         {/* {directors.map((director, index) => (
//           <div key={index} className="flex mr-3 flex-col md:flex-row mb-4">
//             <div className="max-w-5xl h-50 text-white flex flex-col md:flex-row lg:flex-row justofy-center items-center">
//               <div className=" flex justify-center items-center grid grid-cols-1 flex-cols w-full sm:w-1/2">
//                 <img
//                   src={director.imgSrc}
//                   alt={director.name}
//                   className="w-[150px] h-[150px] sm:w-[300px] sm:h-[200px] rounded-full border-4  border-black border-opacity-50 hover:scale-90 transition duration-200 ease-in-out object-fill"
//                   style={{ maxWidth: "50%", margin: "0 auto" }}
//                 />
//                 <h1 className=" text-center p-2">{director.name}</h1>
//                 <h1 className="font-bold text-center ">
//                   {director.designation}
//                 </h1>
//                 <div className="flex justify-center items-center"> */}
//                   {/* <a href={director.add} target='_blank'><img className='bg-black invert rounded-full' height={40} width={40} src={logo} ></img></a> */}
//                   {/* <a href={director.add} target="_blank">
//                     <FontAwesomeIcon
//                       icon={faGoogle}
//                       className="text-3xl text-red-500 p-2"
//                     />
//                   </a>
//                   <a href={director.linkedin} target="_blank">
//                     <FontAwesomeIcon
//                       icon={faLinkedin}
//                       className="text-4xl text-blue-300 p-2"
//                     />
//                   </a>
//                 </div>
//               </div>
//               <div className="max-w-lg p-4 w-full sm:w-1/2">
//                 <div className="border-3 font-montserrat border-white mt-4 text-lg text-justify">
//                   {director.message}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))} */}
//       </div>
//     </div>
//   );
// }

// export default DMssg;

import React from "react";
import Shray_Pathak from "../directorimages/Shray_Pathak.jpeg";
import Atharva from "../directorimages/atharva.jpg";
import shashi from "../directorimages/shashi.png";
import rajeev2 from "../directorimages/rajeev2.png";
import rajeev4 from "../directorimages/rajeev4.jpg";
import naveen from "../directorimages/Naveen1.png";
import Dr_Vivekanand_Shukla from "../directorimages/Vivekanand.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import logo from "../global-images/logo.png";

const directors = [
  {
    imgSrc: rajeev4,
    name: "Prof. Rajeev Ahuja",
    designation: "Chairman",
    message:
      "At TBIF, IIT Ropar, we foster innovation and entrepreneurship by offering startups access to labs, cloud tools, co-working space, mentorship, funding, investor connect, and research support. Our goal is to help students, faculty, and innovators turn ideas into impactful ventures and strengthen India’s entrepreneurial ecosystem.",
    add: "https://iitrpr.irins.org/profile/227381",
    linkedin: "https://scholar.google.com/citations?user=OqyvV_oAAAAJ&hl=en",
  },
  {
    imgSrc: Shray_Pathak,
    name: "Dr. Shray Pathak",
    designation: "Faculty In-Charge",
    message:
      "TBIF at IIT Ropar is a critical driver for innovation and entrepreneurship in the region. By fostering a culture of creativity and enterprise, we aim to transform promising ideas into scalable solutions, providing a launchpad for startups to grow and thrive.",
    add: "https://scholar.google.com/citations?user=JId_NPEAAAAJ&hl=en",
    linkedin:
      "https://www.linkedin.com/in/shray-pathak-4aa852300/?originalSubdomain=in",
  },

  {
    imgSrc: Atharva,
    name: "Atharva Poundarik",
    // designation: 'Member TBIF',

    message:
      "At TBIF, we are committed to creating a vibrant entrepreneurial ecosystem where students, faculty, and regional innovators collaborate to bring ideas to life. Our infrastructure, mentorship, and funding access are designed to support ventures from inception to success.",
    add: "https://iitrpr.ac.in/mme/atharva",
    linkedin: "https://www.linkedin.com/in/atharva-poundarik-44723b44/",
  },
  {
    imgSrc: shashi,
    name: "Dr. Shashi Shekhar Jha",
    // designation: 'Member TBIF',
    message:
      "Through TBIF, IIT Ropar is dedicated to empowering innovators with the tools, guidance, and environment necessary to turn concepts into impactful ventures. We are here to bridge the gap between research and real-world implementation with sustainable solutions.",
    add: "https://iitrpr.irins.org/profile/105191",
    linkedin:
      "https://www.linkedin.com/in/jhashashishekhar/?originalSubdomain=sg",
  },
  {
    imgSrc: naveen,
    name: "Prof. Navin Kumar",
    // designation: 'Member TBIF',
    message:
      "TBIF serves as a catalyst for entrepreneurial growth, offering a nurturing ground for startups to innovate, iterate, and succeed. Our focus is to enable founders with the right support system—mentorship, funding, and strategic guidance—to create lasting impact.",

    add: "https://iitrpr.irins.org/profile/50300",
    linkedin:
      "https://www.linkedin.com/in/navin-kumar-a4a4a45/?originalSubdomain=in",
  },
  {
    imgSrc: Dr_Vivekanand_Shukla,
    name: "Dr. Vivekanand Shukla",
    // designation: 'Member TBIF',
    message:
      "At TBIF, we believe innovation thrives when ideas are nurtured with the right ecosystem. I am committed to guiding startups in transforming their vision into viable ventures through mentorship, strategic planning, and access to networks.",

    add: "https://iitrpr.irins.org/profile/50300",
    linkedin:
      "https://www.linkedin.com/in/vivekanand-shukla-74412b59/?originalSubdomain=in",
  },
];


export default function DMssg() {
  return (
    <section className="p-10 bg-white border-b border-gray-600 pb-20">
      <div className="text-4xl md:flex justify-center gap-2 mt-20 md:text-5xl font-bold text-center text-black mb-8">
        <div className="text-blue-600">Board </div><div> of Directors</div>
      </div>
      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2">
        {directors.map((director, idx) => (
          <div
            key={idx}
            className="bg-zinc-900 rounded-2xl overflow-hidden transform hover:scale-105 transition duration-200"
          >
            <div className="flex flex-col md:flex-row">
              <img
                src={director.imgSrc}
                alt={director.name}
                className="w-full md:w-1/3 object-cover"
              />
              <div className="p-6 flex-1 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-semibold text-white">
                    {director.name}
                  </h3>
                  {director.designation && (
                    <p className="text-md text-gray-300 mb-4">
                      {director.designation}
                    </p>
                  )}
                  <div className="flex justify-start gap-2 items-center"> 
                   {/* <a href={director.add} target='_blank'><img className='bg-black invert rounded-full' height={40} width={40} src={logo} ></img></a> */}
                   <a href={director.add} target="_blank">
                     <FontAwesomeIcon
                       icon={faGoogle}
                       className="text-3xl text-red-500 py-1"
                     />
                   </a>
                   <a href={director.linkedin} target="_blank">
                     <FontAwesomeIcon
                       icon={faLinkedin}
                       className="text-4xl text-blue-500 py-1"
                     />
                   </a>
                 </div>
                  <p className="text-white text-justify">
                    {director.message}
                  </p>
                </div>
                {/* <div className="mt-4 flex space-x-4">
                  {director.googleScholar && (
                    <a
                      href={director.googleScholar}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:text-red-500 text-2xl"
                    >
                      <FontAwesomeIcon icon={faGoogle} />
                    </a>
                  )}
                  {director.linkedIn && (
                    <a
                      href={director.linkedIn}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:text-blue-400 text-2xl"
                    >
                      <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                  )}
                  {director.profile && (
                    <a
                      href={director.profile}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white hover:underline text-lg"
                    >
                      Profile
                    </a>
                  )}
                </div> */}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
